// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import { Api } from './api';
import {Alert, Confirm, Toast, Loading} from 'wc-messagebox'
import { saveLangAndCurrency, IsPC, scroll2Top } from './utils';
import 'wc-messagebox/style.css'
import LoadingPlugin from './components/BGLoading';
//多语言
import i18n from './lang';

Vue.use(Alert)
Vue.use(Confirm)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(LoadingPlugin)

router.beforeEach((to, from, next) => {
  if(to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  store.commit('ROUTERNAME', to.name);
  next();
});

router.afterEach((to, from, next) => {
  scroll2Top();
});


Vue.config.productionTip = false
Vue.prototype.$http = new Api();
// 全局自定义指令
/* 给元素添加背景图片 */
Vue.directive('bgimg',{
  bind (el, binding, vnode) {
    el.style.backgroundImage = `url(${binding.value}`;
  }
});

/* 给元素设置宽度 */
Vue.directive('iwidth', {
  bind (el, binding, vnode) {
    el.style.width = `${binding.value}px`
  }
})
Vue.directive('bgimg',{
  bind (el, binding, vnode) {
    el.style.backgroundImage = `url(${binding.value}`;
  }
});

function urlRedict(){
  if(!IsPC()){
    const divid = 'hotel/';
    const hrefArr = window.location.href.split(divid);
    let result = '';

    if(hrefArr[1]){
      result = `${process.env.WAP_HOST}${divid}${hrefArr[1]}`;
    }else{
      result = `${process.env.WAP_HOST}${divid}`;
    }

    window.location.replace(result);
  }
}

urlRedict();
window.addEventListener("resize", function () {
  urlRedict();
});


/** 本地存储语言类型和货币类型 */
saveLangAndCurrency();


/** 检查是否登录 */
Vue.prototype.$http.checkUserLogin().then((res) => {
  if (res && res.data) {
    store.commit('USERDATA',res.data);
  }
})

/** 获取用户个人资产 */
// Vue.prototype.$http.getUserWallet().then((res) => {
//   store.commit('USERWALLET',res.data);
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js